import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { mapFlagToColor, mapYToTreatmentType } from '../../../resources/weephyt';
function formatWeephytResultForCharts(result, timezone, chartWithD3) {
    return chartWithD3 === true
        ? {
            date: moment.unix(result.x).tz(timezone).toDate(),
            value: result.y
        }
        : {
            x: moment.unix(result.x).tz(timezone),
            y: result.y,
            timestamp: result.x.toString(),
            value: result.y,
            formattedDate: moment.unix(result.x).tz(timezone).format('DD/MM/YY HH:mm'),
            formattedValue: mapYToTreatmentType(result.y),
            flag: result.flag
        };
}
export function sortAndFormatWeephytResult(results, timezone, chartWithD3) {
    const initialRecord = {
        contactHerbicides: [],
        fungicides: [],
        rootAndAntiGerminativeHerbicides: [],
        systemicHerbicides: []
    };
    return !isNil(results)
        ? results.reduce((acc, arrayOfResult, index) => {
            const formattedResult = arrayOfResult.map((res) => {
                return formatWeephytResultForCharts(res, timezone, chartWithD3);
            });
            switch (index) {
                case 0:
                    acc['contactHerbicides'] = formattedResult;
                    break;
                case 1:
                    acc['systemicHerbicides'] = formattedResult;
                    break;
                case 2:
                    acc['rootAndAntiGerminativeHerbicides'] = formattedResult;
                    break;
                case 3:
                    acc['fungicides'] = formattedResult;
                    break;
                default:
                    throw new Error("There shouldn't be 5 arrays in Weephyt response");
            }
            return acc;
        }, initialRecord)
        : initialRecord;
}
/** @deprecated remove with chartWithD3 flag */
export function createWeephytGradientStops(data) {
    let previousOffset = 0;
    return data.reduce((acc, point, index) => {
        const offset = Math.round((index + 1) * (100 / data.length));
        const stopOpacity = point.x.isBefore(moment().add(1, 'hour').startOf('hour')) ? 0.2 : 1;
        const stopColor = mapFlagToColor(point.flag);
        acc.push({
            offset: previousOffset,
            stopOpacity,
            stopColor
        }, {
            offset: offset - 0.001,
            stopOpacity,
            stopColor
        });
        previousOffset = offset;
        return acc;
    }, []);
}
